import { useContext } from 'react';
import { SmartPayOnboardingSteps } from '../../../../types';
import { SignupDialogNavigationContext } from '../contexts/SignupDialogNavigationContextProvider';

export const useSignupDialogNavigation = () => {
    const signupSteps = Object.keys(SmartPayOnboardingSteps);

    const { currentStepIndex, setCurrentStepIndex, isLoadingStep, setIsLoadingStep } = useContext(SignupDialogNavigationContext);

    const nextStep = () => {
        if (currentStepIndex === signupSteps.length) return;
        setCurrentStepIndex(currentStepIndex + 1);
    };

    const previousStep = () => {
        if (currentStepIndex === 1) return;
        setCurrentStepIndex(currentStepIndex - 1);
    };

    const resetFlow = () => {
        setCurrentStepIndex(1);
    };

    const currentStep = signupSteps[currentStepIndex - 1];

    return {
        stepsCount: signupSteps.length,
        currentStepIndex,
        currentStep,
        nextStep,
        previousStep,
        resetFlow,
        isLoading: isLoadingStep,
        setIsLoading: setIsLoadingStep,
    };
};
